import { render, staticRenderFns } from "./LogoModal.vue?vue&type=template&id=12b6e9fa&"
import script from "./LogoModal.vue?vue&type=script&lang=js&"
export * from "./LogoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b6e9fa')) {
      api.createRecord('12b6e9fa', component.options)
    } else {
      api.reload('12b6e9fa', component.options)
    }
    module.hot.accept("./LogoModal.vue?vue&type=template&id=12b6e9fa&", function () {
      api.rerender('12b6e9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SupplierAttribute/LogoModal.vue"
export default component.exports